class ResetPasswordController extends AbstractController
	@register()
	@inject '$stateParams',
		'$state'
		'ToastService'
		'Base64Service'
		'PublicRepository'

	initialize: ->
		if not @$stateParams.token?
			@$state.go 'login'

			return

		@email = null
		@identifier = null
		@password = null
		@passwordConfirm = null
		@token = null
		@errorMessages = {}
		@readToken(@$stateParams.token)
		@validateToken()

	readToken: (token) ->
		try
			tokenData = JSON.parse @Base64Service.decode token

			@email = tokenData.email
			@identifier = tokenData.identifier
			@token = tokenData.token
		catch error
			console.error error
			@onInvalidToken(error)

	validateToken: ->
		if _.isEmpty(@token) or _.isEmpty(@email)
			@onInvalidToken()

			return

		@PublicRepository
			.validatePasswordToken @token
			.then (isValid) =>
				@onInvalidToken() if !isValid

	onInvalidToken: (error = null) ->
		@ToastService.add('general.reset.password.invalid_token', error, 'token', 'error')
		@$state.go 'login'

	reset: ->
		data =
			password: @password
			password_confirm: @passwordConfirm
			email: @email
			identifier: @identifier
			token: @token

		@PublicRepository
			.resetPassword data
			.then =>
				@ToastService.add('wbo.password.reset', null, 'general.success', 'success')

				if @identifier?
					@$state.go('login.identifier', {identifier: @identifier})
				else
					@$state.go('login')
			.catch (response) =>
				@handleErrors(response.data)
				@errorMessages.password = 'wbo.login.error.password.error'
			.finally =>
				@resetPasswordForm.$setPristine()
